import { useRoutes } from "react-router-dom";
import routes from "src/router";

import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";

import { CssBaseline } from "@mui/material";
import ThemeProvider from "./theme/ThemeProvider";
import ReactAlert from "./components/Alerts/ReactAlert";
import "./app.css";

function App() {
  const routing = useRoutes(routes);

  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />
        {routing}
        <ReactAlert />
      </LocalizationProvider>
    </ThemeProvider>
  );
}
export default App;
